import { load } from 'cheerio';

export function extractKBSProductPaths(htmlSource: string): string[] {
    const $ = load(htmlSource);
    const productPathsSet = new Set<string>();

    $('.hireProduct a').each((_, anchor) => {
        const href = $(anchor).attr('href');
        if (href) {
            productPathsSet.add(href);
        }
    });

    return Array.from(productPathsSet);
}
